import client from './client';

export const workoutsApi = {
  // Sessions
  getSessions: (params) => client.get('/workout-sessions', { params }),
  getSession: (id) => client.get(`/workout-sessions/${id}`),
  createSession: (data) => client.post('/workout-sessions', data),
  updateSession: (id, data) => client.put(`/workout-sessions/${id}`, data),
  deleteSession: (id) => client.delete(`/workout-sessions/${id}`),

  // Client sessions (coach view)
  getClientSessions: (clientId, params) =>
    client.get('/workout-sessions', { params: { client_id: clientId, ...params } }),

  // History & PRs
  getSessionHistory: (params) => client.get('/workout-sessions/history', { params }),
  getPRs: () => client.get('/workout-sessions/prs'),
  getExerciseHistory: (exerciseName) =>
    client.get(`/workout-sessions/exercise-history/${encodeURIComponent(exerciseName)}`),

  // Analytics
  getVolumeStats: (params) => client.get('/workout-sessions/volume-stats', { params }),
  getMuscleSplit: (params) => client.get('/workout-sessions/muscle-split', { params }),

  // Exercises
  enrichBatch: (names) => client.post('/exercises/enrich-batch', names),
  getExercises: (params) => client.get('/exercises', { params }),
  getExercise: (id) => client.get(`/exercises/${id}`),
  createExercise: (data) => client.post('/exercises', data),
  updateExercise: (id, data) => client.put(`/exercises/${id}`, data),
  deleteExercise: (id) => client.delete(`/exercises/${id}`),
  getUserRecentExercises: () => client.get('/exercises/user-recent'),
  getSavedExercises: () => client.get('/exercises/saved'),
  toggleSaveExercise: (id) => client.post(`/exercises/${id}/save`),
  getExerciseHistory: (id) => client.get(`/exercises/${id}/history`),
};
